import { useEffect, useRef } from "react"
import { useQueryClient } from "react-query"
import { STORAGE } from "../storage"

const buildWsUrl = () => {
  const token = STORAGE.getToken()
  if (!token) return null
  const baseUrl = process.env.REACT_APP_WEB_SOCKET_URL || `${window.location.protocol === "https:" ? "wss:" : "ws:"}//${window.location.host}`
  return `${baseUrl}/ws/?token=${token}`
}

export const useNotificationWebSocket = () => {
  const queryClient = useQueryClient()
  const wsRef = useRef(null)
  const reconnectTimer = useRef(null)

  useEffect(() => {
    const connect = () => {
      const url = buildWsUrl()
      if (!url) return

      const ws = new WebSocket(url)
      wsRef.current = ws

      ws.onopen = () => {
        // Clear any pending reconnect
        if (reconnectTimer.current) {
          clearTimeout(reconnectTimer.current)
          reconnectTimer.current = null
        }
      }

      ws.onmessage = (event) => {
        try {
          const payload = JSON.parse(event.data)

          if (payload.type === "notification.new") {
            // Invalidate notification queries to trigger refetch via HTTP
            queryClient.invalidateQueries(["getNotificationSummary"])
            queryClient.invalidateQueries(["getNotificationData"])
          } else if (payload.type === "notification.count") {
            // Directly update the summary cache with the unread count
            queryClient.setQueryData(["getNotificationSummary", { exclude_category: "CANCEL_BY_DRIVER" }], {
              data: { data: { unread: payload.unread } },
            })
          }
        } catch {
          // ignore malformed messages
        }
      }

      ws.onclose = () => {
        // Reconnect after 5 seconds
        reconnectTimer.current = setTimeout(connect, 5000)
      }

      ws.onerror = () => {
        ws.close()
      }
    }

    connect()

    return () => {
      if (reconnectTimer.current) clearTimeout(reconnectTimer.current)
      if (wsRef.current) wsRef.current.close()
    }
  }, [queryClient])
}
